export const carouselInicio = [
   
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_787.png",
        "imagenMobile": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_787_V.png",  // ← Versión móvil
        "url": "/Resultados/Migrantes"
    },
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_785.png",
        "imagenMobile": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_785_V.png",  // ← Versión móvil
        "url": "/Resultados/BienestarArtesanos"
    },
    
    {
        "imagen": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_551.png",
        "imagenMobile": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_551_V.png",  // ← Versión móvil
        "url": "https://transparenciadocs.hidalgo.gob.mx/dependencias/contraloriat/dir1/Documentos/TRANSP%20EN%20CORTO_CONVOCATORIA_2026.pdf"
    },
    {
        "imagen": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_875.png",
        "imagenMobile": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_875_V.png",  // ← Versión móvil
        "url": "https://s-medioambiente.hidalgo.gob.mx/pdf/HIDALGO%20JUEGA%20LIMPIO.pdf"
    },
    {
        "imagen": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_342.png",
        "imagenMobile": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_342_V.png",  // ← Versión móvil
        "url": ""
    },
    {
        "imagen": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_341.png",
        "imagenMobile": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_341_V.png",  // ← Versión móvil
        "url": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/vid/CA_350.mp4"
    },
    {
        "imagen": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_337.png",
        "imagenMobile": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_337_V.png",  // ← Versión móvil
        "url": "/DGSP"
    },
    {
        "imagen": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_339.png",
        "imagenMobile": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_339_V.png",  // ← Versión móvil
        "url": ""
    },
   



    
   
]